import { ActionCreator } from 'redux';
import { ApplicationState } from '..';
import {
    GetMailchimpConnectionParamsAction,
    SetMailchimpConnectionParamsAction,
    GetMailchimpListMembersAction,
    GetMailchimpListMembersActionPayload,
    GetMailchimpListsAction,
    SetMailchimpListsAction,
    MailchimpConnectionParams,
    MailchimpPaginationParams,
    MailchimpLists,
    IntegrationsActionTypes,
    IntegrationsState,
    SetMailchimpListMembersProgressAction,
} from './types';

export const GetMailchimpConnectionParams: ActionCreator<GetMailchimpConnectionParamsAction> = (
    tempCode: string
): GetMailchimpConnectionParamsAction => ({
    type: IntegrationsActionTypes.GET_MAILCHIMP_CONNECTION_PARAMS,
    payload: {
        tempCode,
    },
});

export const SetMailchimpConnectionParams: ActionCreator<SetMailchimpConnectionParamsAction> = (
    payload: MailchimpConnectionParams
): SetMailchimpConnectionParamsAction => ({
    type: IntegrationsActionTypes.SET_MAILCHIMP_CONNECTION_PARAMS,
    payload,
});

export const GetMailchimpLists: ActionCreator<GetMailchimpListsAction> = (
    payload: MailchimpPaginationParams
): GetMailchimpListsAction => ({
    type: IntegrationsActionTypes.GET_MAILCHIMP_LISTS,
    payload,
});

export const SetMailchimpLists: ActionCreator<SetMailchimpListsAction> = (
    payload: MailchimpLists
): SetMailchimpListsAction => ({
    type: IntegrationsActionTypes.SET_MAILCHIMP_LISTS,
    payload,
});

export const GetMailchimpListMembers: ActionCreator<GetMailchimpListMembersAction> = (
    payload: GetMailchimpListMembersActionPayload
): GetMailchimpListMembersAction => ({
    type: IntegrationsActionTypes.GET_MAILCHIMP_LIST_MEMBERS,
    payload,
});

export const SetMailchimpListMembersProgress: ActionCreator<SetMailchimpListMembersProgressAction> = (
    payload: number
): SetMailchimpListMembersProgressAction => ({
    type: IntegrationsActionTypes.SET_MAILCHIMP_LIST_MEMBERS_PROGRESS,
    payload,
});

export const getIntegrationsState = (store: ApplicationState): IntegrationsState => store?.integrations;
